import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidAlgorithm } from '../../../mechanics/rid-algorithm/rid-algorithm';

@Component({
  selector: 'app-algorithm-page',
  imports: [RidAlgorithm],
  templateUrl: './algorithm-page.html',
})
export class AlgorithmPage {
  protected readonly $router = inject(Router);
}
